export const setmealApi = {
    list: {
        method: 'post',
        api: 'admin/setmeals/list'
    },
    add: {
      method: 'post',
      api: 'admin/setmeals/add'
    },
    edit: {
      method: 'post',
      api: 'admin/setmeals/edit'
    },
    get: {
      method: 'post',
      api: 'admin/setmeals/get'
    },
    del: {
      method: 'post',
      api: 'admin/setmeals/del'
    },
    changeStatus: {
      method: 'post',
      api: 'admin/setmeals/changeStatus'
    },
  }